import { Badge, Space, Statistic } from "antd";
import { useBuscarReservas } from "../hooks/useBuscarReservas";
import { WarningOutlined } from "@ant-design/icons";
import { TextSubTitle } from "../styles";

export default function BadgeComponent() {
  const { reservas } = useBuscarReservas();

  return (
     <Space
      direction="vertical"
      size={4}
      style={{ width: "100%", textAlign: "center" }}
      align="center" // para centralizar verticalmente, caso tenha múltiplos itens
    >
      <TextSubTitle>Qtd de Reservas sem períodos</TextSubTitle>
      <Statistic value={reservas} />
    </Space>
  );
}
